import { SvgIcon } from '../../../mui/SvgIcon';
import { UxSvgIconProps } from './types';

export function UxRocketLaunch(props: UxSvgIconProps) {
  return (
    <SvgIcon {...props} preserveAspectRatio='xMidYMid meet' viewBox='0 0 19 34'>
      <path
        d='M9.90695 0.0663149C9.59615 0.337643 9.30157 0.612497 9.02178 0.892283C2.96093 
      6.95313 4.13082 15.0253 6.59392 19.9988L13.2566 19.9988C15.712 14.8033 16.891 6.97709 10.895 
      0.98108C10.5849 0.67099 10.2558 0.365833 9.90695 0.0663149ZM11.9514 18.0057L7.88784 
      18.0057C6.73346 15.1303 4.88983 8.39575 9.91681 2.84021C13.8098 7.08703 14.0685 12.6877 
      11.9514 18.0057ZM16.891 15.2339C16.7684 15.8823 16.6232 16.5025 16.4562 17.0938C16.9523 17.8535 
      17.2878 18.8585 17.3731 19.9149C16.9657 19.5104 16.4442 19.2144 15.836 19.0022C15.6457 19.5097 
      15.4498 19.9776 15.2539 20.4131C16.9234 21.1524 17.3392 22.5154 17.5366 23.9855C18.3809 23.0031 
      18.8925 21.5978 18.8918 20.0861C18.8918 18.4582 18.2885 16.7104 16.891 15.2339ZM4.00185 
      19.0051C3.39647 19.2158 2.87707 19.5125 2.47043 19.9149C2.55641 18.869 2.88693 17.8732 3.37321 
      17.1163C3.20548 16.506 3.07017 15.8731 2.95459 15.2332C1.55637 16.709 0.952396 18.4575 0.952396 
      20.0868C0.952396 21.5964 1.46475 23.0038 2.30834 23.9855C2.50567 22.514 2.92147 21.151 4.59243 
      20.4131C4.38241 19.9593 4.18508 19.4899 4.00185 19.0051ZM9.92245 14.0189C9.37134 14.019 8.92593 
      13.5735 8.92594 13.0224C8.92593 12.4713 9.37134 12.0259 9.92245 12.0259C10.4743 12.0266 10.9197 
      12.472 10.9197 13.0231C10.9197 13.5743 10.4729 14.0197 9.92245 14.0189ZM9.92104 7.04193C8.82163 
      7.04193 7.92871 7.93485 7.92801 9.03496C7.92801 10.1358 8.82163 11.0294 9.92175 11.0287C11.0226 
      11.0287 11.9155 10.1358 11.9155 9.03496C11.9155 7.93555 11.0226 7.04263 9.92104 7.04193ZM9.92316 
      9.73337C9.53836 9.73337 9.22475 9.41975 9.22545 9.03566C9.22404 8.65228 9.53836 8.33796 9.92316 
      8.33796C10.3065 8.33796 10.6194 8.65228 10.6209 9.03567C10.6194 9.42046 10.3065 9.73337 9.92316 
      9.73337ZM8.18524 29.324L6.90824 29.324L6.92233 21.9974H8.19934L8.18524 29.324ZM13.0029 27.1238L11.7259 
      27.1238L11.7062 21.9791L12.9832 21.9791L13.0029 27.1238ZM10.5525 33.1896L9.27549 33.1896L9.28254 
      24.1081L10.5595 24.1081L10.5525 33.1896Z'
      />
    </SvgIcon>
  );
}
